import React from 'react';
import { Link } from 'gatsby';

import CDNImage from '../common/cdn-image';

import '../../styles/collections/affinities-promo.scss';

const AffinitiesPromo = (props) => (
  <div className="affinities-promo-wrapper">
    <div className="affinities-promo">
      <div className="affinities-promo__image">
        <Link to="/shop/affinities">
          <CDNImage
            imagePath="/banners/affinities-trade-cover-widget.jpeg"
            alt="Affinities Cover"
          />
        </Link>
      </div>
      <div className="affinities-promo__text">
        <p className="main-info">
          Imagery from this post is featured in<br />
          <span className="title">Affinities</span><br />
          our special book of images created to celebrate 10 years of <i>The Public Domain Review</i>.
        </p>
        <p className="details">
          500+ images – 368 pages<br />
          Large format – Hardcover with inset image
        </p>
        <p>
          <Link
            to="/shop/affinities"
            className="cta"
          >
            Order Today
          </Link>
        </p>
      </div>
    </div>
  </div>
);

export default AffinitiesPromo;
